module.exports = __webpack_public_path__ + "static/img/buildings_logo_low_opacity.e0a24b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buildings_logo_low_opacity.png
// module id = 184
// module chunks = 1